import { replaceRoute } from '../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import SubHeader from '../../components/SubHeader.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import { mapFinalFormErrors } from '../../lib/utils.js';
import PortfolioSettingsFrom from '../../components/portfolio/PortfolioSettingsForm.jsx';
import {
  retrievePortfolio,
  selectPortfolio,
  selectRetrievePortfolioState,
  updatePortfolioCustomFields,
} from '../../modules/portfolio.js';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import PortfolioHeader from '../../components/headers/PageHeaders/Portfolio/PortfolioHeader.jsx';

const mapErrors = mapFinalFormErrors('Failed to save');

const mapStateToProps = (state, ownProps) => ({
  portfolioId: ownProps.portfolioId,
  retrieveSuccess: selectRetrievePortfolioState(state).success,
  portfolio: selectPortfolio(ownProps.portfolioId)(state),
});

const mapDispatchToProps = {
  retrievePortfolio,
  updatePortfolioCustomFields,
};

const randomId = () => Math.random().toString(36).slice(2, 7);

function PortfolioSettingsFormContainer(props) {
  const {
    portfolioId,
    portfolio,
    retrievePortfolio,
    updatePortfolioCustomFields,
    retrieveSuccess,
    slug,
  } = props;

  const [columns, setColumns] = useState(null);

  const redirectToPortfolio = () =>
    replaceRoute('portfolio/show/info', { portfolioId });

  const onSubmit = () => {
    const underscoreFilter = () =>
      columns
        .filter((column) => column.name)
        .map((column) => {
          column.name = column.name.replace(/_/g, '-');
          return column;
        });

    updatePortfolioCustomFields(portfolioId, {
      custom_fields: underscoreFilter(),
    })
      .then(() => redirectToPortfolio())
      .catch(mapErrors);
  };

  const validate = (values) => {};

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((item, index) => ({ ...item, priority: index }));
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) return;

    const items = reorder(
      columns,
      result.source.index,
      result.destination.index
    );

    setColumns(items);
  };

  const onCreateColumn = () =>
    setColumns([
      ...columns,
      {
        id: null,
        allow_delete: true,
        allow_editor: true,
        editor: false,
        key: '',
        name: '',
        mandatory: false,
        native_column: null,
        owner_id: portfolioId,
        owner_type: 'Portfolio',
        priority: columns.length,
        table_show: true,
        using_object: 'portfolio',
        draggableId: randomId(),
      },
    ]);

  const onDeleteColumn = (draggableId) => {
    const { name } = columns.find(
      (column) => column.draggableId === draggableId
    );
    if (
      !window.confirm(
        'Are you sure you want to change the field type? Text formatting will be lost.'
      )
    )
      return;

    setColumns(columns.filter((column) => column.draggableId !== draggableId));
  };

  const onColumnNameChange = (value, itemIndex) => {
    setColumns(
      columns.map((item, index) =>
        itemIndex === index ? { ...item, name: value } : item
      )
    );
  };

  const onContentTypeChange = (itemIndex) => {
    if (
      columns[itemIndex].editor &&
      columns[itemIndex].id &&
      !window.confirm(
        'Are you sure you want to change the field type? Text formatting will be lost.'
      )
    )
      return;

    setColumns(
      columns.map((item, index) =>
        itemIndex === index ? { ...item, editor: !item.editor } : item
      )
    );
  };

  useEffect(() => {
    retrievePortfolio(portfolioId);
  }, []);

  useEffect(() => {
    if (retrieveSuccess && portfolio) {
      setColumns(
        (portfolio.custom_fields || portfolio.customFields).map((item) => ({
          ...item,
          draggableId: item.draggableId || randomId(),
        }))
      );
    }
  }, [retrieveSuccess]);

  return retrieveSuccess ? (
    <React.Fragment>
      <PortfolioHeader portfolio={portfolio} slug={slug} portfolioTabs />

      <SubHeader flexJustify small>
        <h2>Customize {getOrgTermsContent('portfolio')}</h2>
      </SubHeader>

      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  {columns ? (
                    <Form
                      onSubmit={onSubmit}
                      validate={validate}
                      onDragEnd={onDragEnd}
                      onCreateColumn={onCreateColumn}
                      onColumnNameChange={onColumnNameChange}
                      onDeleteColumn={onDeleteColumn}
                      onContentTypeChange={onContentTypeChange}
                      data={columns}
                      slug={slug}
                      portfolioId={portfolioId}
                      component={PortfolioSettingsFrom}
                    />
                  ) : null}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  ) : (
    <Empty simplified content={loadingContent} />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PortfolioSettingsFormContainer);
